module.exports = __webpack_public_path__ + "img/BEL.a68ab8b9.svg";